<template>
  <div class="statements">
    <CardStack
      ref="cardStack"
      key-name="key"
      :queue.sync="statementQue"
      :offset-y="-15"
      :allowSuper="false"
      @submit="onSubmitStatement"
    >
      <template slot-scope="scope">
        <Card :statement="scope" :active="scope.index === 0" />
      </template>

      <template slot="like">
        <img class="like-pointer" src="images/icons/thumb-up.svg" />
      </template>

      <template slot="nope">
        <img class="nope-pointer" src="images/icons/thumb-down.svg" />
      </template>
    </CardStack>

    <Controls />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { mapFields } from "vuex-map-fields";
import CardStack from "vue-tinder";
import Controls from "@/components/Statement/Controls";
import Card from "@/components/Statement/Card";

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default {
  name: "Statements",

  components: {
    Controls,
    CardStack,
    Card,
  },

  computed: {
    ...mapFields(["currentStatementIndex", "statementQue", "statementHistory"]),
    ...mapGetters(["minimumThemesSelected", "noMoreStatements"]),
  },

  watch: {
    // navigate to the results page when last statement is clicked
    noMoreStatements() {
      if (this.noMoreStatements) {
        this.$router.push({ name: "results" });
      }
    },
  },

  // validate route, are there enough themes selected?
  // if not, redirect back to selectTheme view
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.minimumThemesSelected === false) {
        vm.$router.push({ name: "selectTheme" });
      }
    });
  },

  mounted() {
    this.$nextTick(() => this.scrollToEnd());
  },

  methods: {
    ...mapActions(["onSubmitStatement"]),
    ...mapMutations(["setCurrentStatementIndex"]),

    scrollToEnd() {
      gsap.set(window, { scrollTo: { y: "max" } });
    },

    decide(position) {
      const type = this.$convertType({ type: position, reverse: true });
      this.$refs.cardStack.decide(type);
    },

    back() {
      this.$refs.cardStack.rewind([this.statementHistory.pop()]);
      this.setCurrentStatementIndex(this.currentStatementIndex - 1);
    },

    next() {
      // the plugin doesnt have a next function
      // this is a way of using the down animation and restore the previous chosen position
      // if the user doesn't change it by clicking next
      const itemPosition = this.statementQue[0].position;
      const type = this.$convertType({ type: itemPosition, reverse: true });

      this.$refs.cardStack.decide(type);

      //this.$refs.cardStack.decide("down");
      this.statementHistory.at(-1).position = itemPosition;
    },
  },
};
</script>

<style lang="scss" scoped>
.statements {
  // prevent scrollbars when dragging cards
  overflow-y: hidden;
}

.controls {
  margin-top: 0;
}

.vue-tinder {
  width: 100%;
  max-width: 450px;
  height: 65vh;
  max-height: 670px;
  margin: auto;
}

:deep() {
  .tinder-card {
    border-radius: $border-radius !important;
    min-height: 400px;
  }

  .pointer-wrap {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-blend-mode: multiply;
    backdrop-filter: blur(30px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .nope-pointer-wrap {
    background: rgba(255, 6, 22, 0.3);
  }

  .like-pointer-wrap {
    background: rgba(62, 207, 125, 0.3);
  }

  .like-pointer,
  .nope-pointer {
    display: block;
    width: 30%;
    height: auto;
  }
}
</style>
